export var ResourceType;
(function (ResourceType) {
    ResourceType["AwsEc2"] = "AWS_EC2";
    ResourceType["AwsRds"] = "AWS_RDS";
    ResourceType["AwsS3"] = "AWS_S3";
    ResourceType["AwsEfs"] = "AWS_EFS";
    ResourceType["AwsFsx"] = "AWS_FSX";
    ResourceType["AwsEksNamespace"] = "AWS_EKS_NAMESPACE";
    ResourceType["AwsDynamoDb"] = "AWS_DYNAMO_DB";
    ResourceType["AwsEbsVolume"] = "AWS_EBS_VOLUME";
    ResourceType["AwsKeyspacesTable"] = "AWS_KEYSPACES_TABLE";
    ResourceType["AwsCassandraCluster"] = "AWS_CASSANDRA_CLUSTER";
    ResourceType["AwsDocumentdb"] = "AWS_DOCUMENTDB";
    ResourceType["AwsNeptune"] = "AWS_NEPTUNE";
    ResourceType["AzureVirtualMachine"] = "AZURE_VIRTUAL_MACHINE";
    ResourceType["AzureFileShare"] = "AZURE_FILE_SHARE";
    ResourceType["AzureStorageAccount"] = "AZURE_STORAGE_ACCOUNT";
    ResourceType["AzureDisk"] = "AZURE_DISK";
    ResourceType["AzureSqlDatabase"] = "AZURE_SQL_DATABASE";
    ResourceType["AzureSqlManagedInstance"] = "AZURE_SQL_MANAGED_INSTANCE";
    ResourceType["AzureSqlVirtualMachine"] = "AZURE_SQL_VIRTUAL_MACHINE";
    ResourceType["AzureSapHanaVm"] = "AZURE_SAP_HANA_VM";
    ResourceType["AzureMysql"] = "AZURE_MYSQL";
    ResourceType["AzurePostgresql"] = "AZURE_POSTGRESQL";
    ResourceType["AzureCosmosdbMongodb"] = "AZURE_COSMOSDB_MONGODB";
    ResourceType["AzureCosmosdbNosql"] = "AZURE_COSMOSDB_NOSQL";
    ResourceType["AzureAksNamespace"] = "AZURE_AKS_NAMESPACE";
    ResourceType["AzureCassandraCluster"] = "AZURE_CASSANDRA_CLUSTER";
    ResourceType["AtlasMongodbCluster"] = "ATLAS_MONGODB_CLUSTER";
    ResourceType["GcpComputeEngineInstance"] = "GCP_COMPUTE_ENGINE_INSTANCE";
    ResourceType["GcpCloudSqlInstance"] = "GCP_CLOUD_SQL_INSTANCE";
    ResourceType["GcpCloudStorageBucket"] = "GCP_CLOUD_STORAGE_BUCKET";
    ResourceType["GcpGkeNamespace"] = "GCP_GKE_NAMESPACE";
    ResourceType["GcpBigQuery"] = "GCP_BIG_QUERY";
    ResourceType["GcpCloudFirestore"] = "GCP_CLOUD_FIRESTORE";
    ResourceType["GcpDisk"] = "GCP_DISK";
    ResourceType["GcpSapHanaVm"] = "GCP_SAP_HANA_VM";
    ResourceType["GcpCassandraCluster"] = "GCP_CASSANDRA_CLUSTER";
    ResourceType["GoogleWorkspaceResource"] = "GOOGLE_WORKSPACE_RESOURCE";
    ResourceType["Microsoft365Resource"] = "MICROSOFT_365_RESOURCE";
    ResourceType["ResourceTypeUnspecified"] = "RESOURCE_TYPE_UNSPECIFIED";
})(ResourceType || (ResourceType = {}));
